import React, { createContext, useContext, useState, useEffect } from 'react';

const CartContext = createContext();

function loadCart() {
  try {
    const saved = localStorage.getItem('binco_cart');
    return saved ? JSON.parse(saved) : [];
  } catch { return []; }
}

export function CartProvider({ children }) {
  const [items, setItems] = useState(loadCart);

  useEffect(() => {
    localStorage.setItem('binco_cart', JSON.stringify(items));
  }, [items]);

  function addItem(product, size, quantity, color) {
    setItems(prev => {
      const existing = prev.find(
        item => item.product.id === product.id && item.size === size && item.color === color,
      );
      if (existing) {
        return prev.map(item =>
          item.product.id === product.id && item.size === size && item.color === color
            ? { ...item, quantity: item.quantity + quantity }
            : item,
        );
      }
      return [...prev, { product, size, quantity, color }];
    });
  }

  function removeItem(productId, size, color) {
    setItems(prev =>
      prev.filter(
        item => !(item.product.id === productId && item.size === size && item.color === color),
      ),
    );
  }

  function updateQuantity(productId, size, color, quantity) {
    if (quantity <= 0) {
      removeItem(productId, size, color);
      return;
    }
    setItems(prev =>
      prev.map(item =>
        item.product.id === productId && item.size === size && item.color === color
          ? { ...item, quantity }
          : item,
      ),
    );
  }

  function clearCart() {
    setItems([]);
  }

  function getTotal() {
    return items.reduce(
      (sum, item) => sum + item.product.price * item.quantity,
      0,
    );
  }

  function getItemCount() {
    return items.reduce((sum, item) => sum + item.quantity, 0);
  }

  return (
    <CartContext.Provider
      value={{ items, addItem, removeItem, updateQuantity, clearCart, getTotal, getItemCount }}
    >
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  return useContext(CartContext);
}
